import { Avatar } from "primereact/avatar";
import InstaIcon from "assets/icons/insta.svg";
import SpotifyIcon from "assets/icons/spotify.svg";
import TwitterIcon from "assets/icons/x.svg";
import AppleIcon from "assets/icons/apple.svg";
import FacebookIcon from "assets/icons/facebook.svg";
import TiktokIcon from "assets/icons/tiktok.svg";
import CloudIcon from "assets/icons/cloud.svg";
import YoutubeIcon from "assets/icons/youtube.svg";
import { Button } from "primereact/button";
import UserImg from "assets/images/usernew.png";
import { useNavigate } from "react-router-dom";
import { OutlineCustomButton } from "shared/components/inputButton";
import TableComponent from "shared/components/table";
import Page from "shared/components/Page";
import CustomHeading from "shared/components/CustomHeading";
import CustomCard from "shared/components/CustomCard";
import CustomLabel from "shared/components/CustomLabel";
import CustomGrid from "shared/components/CustomGrid";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getProfileAction } from "store/actions/UserActions";
import { ProfilePicViewInput } from "shared/components/AllViewInputs";
import CustomForm from "shared/components/CustomForm";
import ProfileContainer from "./ProfileContainer";
import { getSocialLinkIcon } from "utils/common";

export default function ViewProfile() {
    const { data, socialLinks } = ProfileContainer()
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Custom template for the Cover column
    const CoverImageTemplate = (workData) => {
        return <img src={workData.cover} width={50} alt="user" />;
    };
    // Data for the table
    const workData = [
        {
            cover: UserImg, // Ensure this path is correct
            trackname: "Being an artist ain’t easy",
            date: "Aug 25, 2021",
            credit: "Credit",
        },
    ];

    // Column configuration for the table
    const workColumns = [
        {
            field: "cover",
            header: "Cover",
            bodyTemplate: CoverImageTemplate
        },
        { field: "trackname", header: "Track Name" },
        { field: "date", header: "Release Date" },
        { field: "credit", header: "Credit" },
    ];

    // const SocialTray = [
    //     {
    //         icon: TwitterIcon,
    //         label: "jayneleesings",
    //         link: "",
    //     },
    //     {
    //         icon: InstaIcon,
    //         label: "jayneleesings",
    //         link: "",
    //     },
    //     {
    //         icon: FacebookIcon,
    //         label: "jayneleesings",
    //         link: "",
    //     },
    //     {
    //         icon: TiktokIcon,
    //         label: "jayneleesings",
    //         link: "",
    //     },
    //     {
    //         icon: SpotifyIcon,
    //         label: "jayneleesings",
    //         link: "",
    //     },
    //     {
    //         icon: AppleIcon,
    //         label: "jayneleesings",
    //         link: "",
    //     },
    //     {
    //         icon: YoutubeIcon,
    //         label: "jayneleesings",
    //         link: "",
    //     },
    //     {
    //         icon: CloudIcon,
    //         label: "jayneleesings",
    //         link: "",
    //     },
    // ];

    const header = () => {
        return (
            <OutlineCustomButton
                label="Edit Profile"
                icon="pi pi-pencil"
                onClick={() => navigate("/profile/edit")}
            />
        )
    }

    return (
        <Page>
            <div className="flex flex-column md:flex-row gap-6">
                <div className="profile-left">
                    <ProfilePicViewInput src={data?.profilePicture} name="profilePicture" />
                </div>

                <div className="profile-right">
                    <CustomHeading title={data?.fullName} discription={data?.category} header={header()} />
                    <CustomForm>
                        <CustomLabel title={"Label/Distribution"} secondaryTitle={data?.distributor} extraClassName={"mt-4"} />
                        <CustomLabel title={"Publisher"} secondaryTitle={data?.publisher} extraClassName={"mt-4"} />
                    </CustomForm>
                    <CustomLabel title={"About me"} extraClassName={"mt-4"} />
                    <p className="text-lg font-normal karla">
                        {data?.aboutMe}
                    </p>
                    <TableComponent data={workData} columns={workColumns} label="My Works" />
                    <CustomForm >
                        <CustomLabel title={"Socials"} extraClassName={"mt-4"} />
                    </CustomForm>
                    <CustomGrid>
                        {/* {SocialTray.map((item, index) => (
                            <div className="lg:col-4">
                                <a
                                    key={index}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex align-items-center gap-2 hover:text-blue-500"
                                >
                                    <img src={item.icon} alt={`${item.label} icon`} />
                                    <span className="text-sm text-black-alpha-90 font-medium">
                                        {item.label}
                                    </span>
                                </a>
                            </div>
                        ))} */}
                        {socialLinks.map((item, index) => {
                            const icon = getSocialLinkIcon(item?.type)
                            return (
                                <div className="lg:col-4">
                                    <a
                                        key={index}
                                        href={item.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex align-items-center gap-2 hover:text-blue-500"
                                    >
                                        {icon && <img src={icon} alt={`${item.type} icon`} />}
                                        <span className="text-sm text-black-alpha-90 font-medium">
                                            {item.type}
                                        </span>
                                    </a>
                                </div>
                            )
                        })}
                    </CustomGrid>
                </div>
            </div>
        </Page>
    );
}
